<template>
    <div class="container">
        <p class="content">《聊天室服务协议》系长沙珈颜网络科技有限公司（以下简称“我方”）与您（您为自然人）约定的为了更好的规范和明确双方权利与义务且具有法律效力的电子协议，
            下称“本协议”。您勾选“我同意”或点击“我已阅读并遵守该协议”按钮，即表示您已经仔细阅读且能充分理解并自愿接受本协议的所有条款。请您在使用聊天室服务前仔细阅读本协议，
            确保您已充分理解本协议中各条款的内容。特别是涉及免除或者宪制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。
        </p>

        <p class="contentBlack">
            您点击同意本协议及在平台使用聊天室功能的行为将视为对本协议的接受，并承诺作为本协议的一方当事人接受本协议的约束在您阅读本协议的过程中，
            如您不同意本协议或其中任何条款的约定，您应立即停止使用本公司提供的聊天室及相关服务。
        </p>

        <p class="content">“聊天室”服务所包含内容分为在线多人语音/视频聊天功能及文字聊天功能组合构成，属于平台的版块之一，因此同时适用平台规则所有条款的约定。</p>
        <p class="contentBlack">定义：</p>
        <span class="content">聊天室：指互联网用户通过平台建立的，用于群体在线交流信息的网络空间。</span>
        <span class="content">房主：在平台上有权限开通语音视频聊天室的房间主持人，类似互联网群组提供信息服务的建立者、管理者。</span>
        <span class="content">连麦：指多名互联网用户通过语音视频聊天功能在聊天室进行交流互动的行为。</span>
        <span class="content">平台：长沙珈颜网络科技有限公司（即觅趣app）。</span>

        <p class="contentBlack">第一条 用户服务确认</p>
        <span class="content">1、各方确认，我方为平台的有权开发商、内容提供方和运营商，为长沙珈颜网络科技有限公司旗下平台（即觅趣 app）提供视频内容服务的储存、介入、播放以及内容运营。</span>
        <span class="content">2、您是中华人民共和国（下称“中国”）公民，且您已年满18周岁，具有完全民事行为能力。若您不具备前述条件，您应立即终止注册或停止使用。</span>
        <span class="content">3、您根据本协议和平台规则，在平台上开通聊天室服务，为平台用户提供在线视频/语音直播分享以及在线互动。您在平台提供服务期间均应视为协议期内。平台有权对您上传或由您参与、
            编辑、制作的内容（包括但不限于图片、海报、头像、音频、视频等）进行形式审核。但您仍需对上述内容的真实性、合法性、准确性、及时性等承担相应的法律责任。</span>
        <span class="content">4、您在注册或使用本服务的过程中，根据国家相关法律法规，您需要填写或提交一些必要的信息以及提交材料供平台审核。如您提交的信息不完整或不符合法律法律规定或平台有关规定的，
            则您可能无法注册成功或您使用本服务的过程中会受到限制。若您的个人信息发生变更，您须及时向平台进行更新。</span>
        <span class="content">5、您在平台开通聊天室服务以及在线互动，获得道具（礼物）分成（用户赠送的虚拟道具、礼物，等分成部分收益），具体收益分成、提现方式等以平台规定聊天室收入领取规则为准。</span>
        <span class="content">6、根据国家相关法律法规，您应依法纳税。您的平台收益相关纳税申报、税费及相关责任义务等由您与您的合作方（灵活用工平台等）自行约定，与我方/平台方无关。</span>
        <span class="content">7、各方确认，您不是我方员工，也并未向我方输出劳务，您作为自由职业者/个体工</span>
        <span class="content">8、商户入驻我方经营文化娱乐相关活动，开通聊天室服务为平台用户输出在线视频/语音直播分享以及在线互动内容/服务，并获取增值服务收入，你、我双方对平台用户的收入享有分成比例，
            故您与我方属商事合作关系，不构成雇佣、兼职或其他劳务关系。</span>



        
        
        <p class="contentBlack">第二条 服务规则</p>
        <span class="content">1、我方有权定期或不定期对平台（如互联网网站、移动网络）协议、规则、及行为规范等进行修订及变更，您对此表示理解和同意。</span>
        <span class="content">2、我方有权根据您的申请或平台公布的规则，将聊天室管理工作交由您的工作室、经济公司委托的其他第三方机构（下称“公会”）负责。</span>
        <span class="content">3、我方和公会有权根据平台规则对您进行考核、评价（考核、评价标准包括但不限于聊天室使用时长、用户观看数量、用户赠与的虚拟礼物数量和种类、
            用户支持度、用户投诉情况、违法违规情况等），以确定您的虚拟道具和收入；如果您在使用聊天室的过程中违反法律、法规或平台规则与规范。平台和公会将采取惩罚措施
            （包括但不限于扣除您的收益、禁播、关闭您的聊天室、以及封禁您的账户）。</span>
        <span class="content">4、我方有权对您在平台上所做的聊天室服务提出改进建议和意见，您应在收到我方的建议或意见后立即进行整改，否则我方有权采取前述惩罚措施。</span>
        <span class="content">5、我方有权根据法律法规的规定或相关部门的要求对您的视频/语音内容（包括但不限于图片、海报、头像、音频、视频等）的合法性进行审查。
            如果视频/语音内容存在违法、违规、侵害平台或第三方合法权益的情形，平台有权采取关停聊天室、删除内容、注销账户、配合主管部门调查等措施。</span>
        <span class="content">6、平台有权在您的聊天室内标注带有平台的LOGO（或名称）和时间的水印。</span>
        <span class="content">7、平台负责提供您使用聊天室服务的平台，并提供平台技术服务支持。但我方不担保网络服务一定能满足您的任何要求，不担保网络服务时刻通畅，不担保网络服务的及时性、安全性、准确性。</span>
        <span class="content">8、平台将通过平台内公告、平台消息推送、电子邮件、手机短信或常规信件传送等方式与您联系或发送相关通知。该等通知于发送之日即视为已送达。</span>
        <span class="content">9、鉴于视频/语音直播服务的特殊性，您同意平台有权随时变更、中断或终止聊天室服务。如变更、中断或终止聊天室服务而造成任何损失，我方无需对您或任何第三方承担任何责任，
            但我方会尽量在变更、中断或终止服务之前事先以公告、邮件或系统弹窗等形式通知用户。</span>
        <span class="content">10、我方有权根据自身经营管理的需要，制定、修改公会签约及聊天室成员提现的规则或方案。您理解并同意前述所制定、修改的规则或方案，且将严格遵守前述所制定、修改的规则或方案。</span>
        <span class="content">11、我方对于您的注册资格及审核通过、语音聊天室成员管理等享有最终决定权，您无权对此提出任何异议及主张由此产生的相关诉权。</span>





        <p class="contentBlack">第三条 使用规则</p>
        <span class="content">1、您承诺不会因履行本协议损害第三方合法利益或违反中国法律、法规、规范性规定等，您接受并履行本协议不违反任何对您有约束力的法律文件，亦不会使我方对任何第三方承担任何责任。</span>
        <span class="content">2、您保证有条件、能力、资源、资格履行本协议约定的开通、使用聊天室职责及义务。</span>
        <span class="content">3、您了解并同意，您基于平台产生的全部收益最终以平台后台数据为准；同时您需遵守我方在平台不时更新的各项包括但不限于平台运营制度及聊天室管理规则与要求
            （下称“平台规则及聊天室规范”），以及国家关于该类互联网服务的法律、法规、规范性规定等。</span>
        <span class="content">4、您同意我方免费使用您的名称（包括但不限于您真实姓名、笔名、网名、曾用名及任何代表您身份的文字符号）和肖像（包括但不限于真人消息及卡通肖像等）
            进行平台及关联企业的各类宣传和推广，并给予必要的配合。</span>
        <span class="content">5、您保证对您在平台上传的图片、海报、头像等所有内容拥有所有权或合法使用权，有权上传到平台并有权授权平台使用。您确认在使用视频/语音直播服务过程中有任何不担当行为，
            或违反法律法规和平台的先关运营规则，或侵犯第三方合法权益，都由您自行承担相应责任，我方无需承担任何责任。如因您的行为而给我方造成损害的，您应予赔偿，我方有权从您的分成费用中直接扣除上述赔偿费用。</span>
        <span class="content">6、您应自行承担使用聊天室服务所需要的网络、支持视频和语音的设备（包括但不限于为接入互联网而支付电话费及上网费、未使用移动网而支付的手机费），
            并保证视频图像和语音质量的清晰、稳定。若因您的网络原因造成视频/语音服务卡顿或无法观看，我方有权要求您升级网络，您应在收到我方的建议或意见后3日内进行相应的整改，否则我方有权采取相应的惩罚措施。</span>
        <span class="content">7、您在平台提供的视频/语音直播服务和发布的所有信息、咨询、言论等均不得涉政、涉枪、涉赌、渉暴、涉黄或其他含有任何违反中国法律、法规及规范性规定的内容，包括但不限于危害国家安全、淫秽色情、
            虚假、诽谤、恐吓骚扰他人、侵犯他人知识产权、商业秘密或其他合法权益以及有违社会公序良俗的内容或指向上述内容的方式。</span>
        <span class="content">8、您须提供真实、准确且合法有效的个人身份信息及联系方式以完成实名认证；若个人信息或联系方式发生变更，您须及时进行更新。</span>
        <span class="content">9、您承诺遵守诚实信用原则，不扰乱平台的正常秩序，未经我方同意不得发布商业广告，不从事与聊天室服务无关的活动。</span>
        <span class="content">10、您注册的账号和密码是您接受平台服务的唯一身份凭证，由您自行负责保管并设置密码，禁止赠与、借用、租用、转让或者售卖。您应当对以您账号进行的所有活动和事件承担全部法律责任。</span>
        <span class="content">11、您承诺上述信息包括但不限于在平台使用的各类账户、银行卡（包括信用卡）、第三方支付账户及对应密码等重要资料，不在使用平台服务过程中透露，也不会将涉及您隐私的信息发表、
            上传或通过平台服务提供给其他人，否则由此产生的责任和损失应由您自行承担，</span>
        <span class="content">12、您保证不做出任何有损于平台形象、品牌之行为，否则我方有权解除协议并要求您承担全部赔偿责任。</span>
        <span class="content">13、本协议期间及本协议终止后，您均不得以任何方式散播宣传任何有损我方声誉及形象之言论、图片、视频等，不得以任何方式损害我方利益，否则我方有权要求您进行赔偿
            （包括但不限于扣减虚拟道具和收入，乃至直接封停您的账户）。</span>
        <span class="content">14、如您的聊天室语音、视频内容有第三方参与，您应保证与第三方不存在任何的法律纠纷，若存在上述纠纷由您单独负责，概与我方无涉。若造成我方损失的，您应向我方赔偿该等损失。</span>
        <span class="content">15、您承诺积极维护我方及平台形象，您不得作出有损于我方或平台形象或利益的行为。本协议期内及协议终止后，您不得通过任何渠道以任何方式发布暗示或不利于我方或平台的言论。</span>
        <span class="content">16、您不得在任何场合以任何形式（包括但不限于在个人动态、个人资料页、聊天室名称、海报等）提及或展示其他平台的名称、LOGO、注册号、图片、不得引导平台现有用户、
            其他您或我方员工进入其他平台或为其提供任何服务、信息或便利，否则我方有权对您的违约行为进行处罚。</span>
        <span class="content">17、我方只提供平台服务，如您自行与工作室、经纪公司或其他第三方机构建立合同关系，因此所产生的纠纷均与我方无关，我方将不承担任何责任。</span>
        <span class="content">18、如您受与您签订相关经纪或劳务关系的工作室、经纪公司或其他第三方机构的委派到平台进行互动的，您在平台获得的虚拟道具和收入将由我方全部支付给上述机构，并由上述机构与您结算，
            您同意不得在任何时间以任何方式就上述虚拟道具或收入向我方提出任何权利请求。</span>
        <span class="content">19、您应当使用真实身份信息、电话号码等相关个人信息资料进行注册，不得以虚假、冒用的居民身份信息、进行注册并认证。若您的个人信息资料有任何变动，应及时更新。
            您须为年满18周岁且具有完全民事行为能力的自然人。您承诺不会因执行本协议损害任何第三方合法利益，您自愿接受并履行本协议约定的任何条款不违反任何对您有约束力的法律文件，亦不会使我方对任何第三方承担任何责任。</span>
        <span class="content">20、您本平台上发布的所有信息/资讯/言论/等均不得含有任何违反中华人民共和国有关法律、法规等相关规定的内容，包括但不限于涉及危害国家安全、淫秽色情、虚假、诽谤（包括商业诽谤）、
            恐吓、骚扰或者侵犯他人知识产权、人身权、商业秘密等其他合法权益，以及提供有违公序良俗的信息或指向这些信息的链接。</span>
        <span class="content">21、您有义务保证语音以及视频环境健康有序，您需对自己的文字、语音内容、语音内容负责，禁止涉黄、涉赌、欺诈、广告营销、索要红包等行为，我方运营团队24小时巡查监督，
            一经发现您或其他聊天室成员存在违规行为的，平台有权撤销房主资格，关闭聊天室，并向您追究相应的民事及刑事责任。</span>
        <span class="content">22、您有权创建/关闭属于自己的聊天室</span>
        <span class="content">（1）聊天室内进行语音聊天互动的（简称：连麦），最多允许8名成员同时进行，连麦人员人满之后，必须等待一位连麦人员离开，下一位用户才能进行连麦互动。</span>
        <span class="content">（2）房主有权对聊天室成员进行管理如：允许聊天室内成员上麦、强制成员下麦、禁止成员语音聊天、文字交流，等等。您应当对聊天室内成员的语音文字聊天内容进行管控，
            保证聊天室内言论不得涉黄违法、不得违反我国现行的法律法规。</span>
        <span class="content">若聊天室内容涉黄违法、违反本合同条款、平台相关规定以及我国现行法律法规的，房主应当立马采取管理手段制止或者举报及时通告我方或官方运营人员。房主不制止不管理甚至参与的，
            我方有权对您作出处罚而无需您同意，如取消房主资格、封号、没收、扣除结算费用等。若情况严重，我方有权通过法律途径进行追责且主张赔偿金。</span>
        <span class="content">（3）聊天室封面需要我方审核通过后才可使用。</span>
        <span class="content">（4）房主开启语音聊天室，因平台功能限制，则无法同时使用一对一视频/语音聊天功能、直播功能。</span>
        <span class="content">（5）依据《互联网群组信息服务管理规定》，本平台群组（下简称房间），成员人数上限300人（每个房间的最多容纳观众人数300人），每位用户只能建立1间房间、每个用户能同时参加房间的上限是1间。</span>
        <span class="content">23、依据《互联网群组信息服务管理规定》互联网群组建立者、管理者（即本文所称房主）应当履行群组管理责任，在使用开房服务时依据法律法规、用户协议和平台公约，
            应该规范群组内群成员的网络行为和房间内信息发布，房主有责任构建文明有序的网络群体空间”的法律法规。</span>







        <p class="contentBlack">第四条 知识产权</p>
        <span class="content">1、直播视频/语音服务包括我方运营的网站、移动应用软件以及内涵的文字、图片、视频、音频等元素，我方对其服务标志、标识以及上述任何元素享有全部的知识产权。</span>
        <span class="content">2、您不得对平台服务设计的相关网页、应用、软件等产品进行反向工程、反向汇编、反向编译等行为。</span>
        <span class="content">3、您在平台提供聊天室服务期间产生的成果以及上传发布的文字、图片、音视频以及表演等用户原创的信息（包括但不限于视频、音频，及与本协议事项相关的任何文字、视频、音频等，
            以下统称“成果”），您许可我方在全世界范围内免费的、永久性的、不可撤销的、独家的和转授权之权利，包括但不限于：复制权、发行权、出租权、摄制权、改编权、翻译权、
            汇编权以及《著作权法》规定的由著作权人享有的其他著作财产权利及邻接权利。我方可将前述信息在我方及关联方运营的平台上使用，可再次编辑后使用，也可以由我方授权给合作方使用。</span>
        <span class="content">对于以盗用、刊登、转载、复制等任何方式侵犯上述成果的著作权、著作邻接权以及其他合法权益的行为，我方有权以自身名义进行维权。</span>








        <p class="contentBlack">第五条 保密制度</p>
        <span class="content">1、您应严格遵守我方的保密制度，承诺无限期保守我方的商业秘密。因您违反约定使用或披露我方商业秘密和信息使我方遭受任何名誉、声誉或经济上的、直接或间接的损失，
            您应赔偿我方违约金，我方有权扣除您在平台获取的虚拟道具或收入用以抵扣我方损失。若您的收益不足以弥补我方损失的，您还应赔偿我方损失。</span>
        <span class="content">2、商业秘密是指由我方提供的、或者您在双方合作期间了解到的、或者我方对第三方承担保密义务的，与我方业务有关的，能为我方带来经济利益，具有实用性的、非公知的所有信息，
            包括（但不限于）：技术信息、经营信息和与我方行政管理有关的信息和文件（含本协议及相关协议内容）、您从我方获得的服务费用的金额和结算方式、标准、权利归属方式、授权方式、客户名单、
            其他解说员的名单、联系方式、服务费用、我方工作人员名单等不为公众所知悉的信息。</span>
        <span class="content">3、您应严格遵守本协议，未经我方书面授权或同意，对我方的商业秘密不得：</span>
        <span class="content">（1）以任何方式向第三方或不特定的公众进行传播、泄露；</span>
        <span class="content">（2）为非本协议的目的而使用我方的商业秘密。</span>
        <span class="content">4、本协议终止后，您应将我方商业秘密悉数返还我方，或在我方监督下，将记载我方商业秘密的全部文件销毁。</span>
        <span class="content">5、本条规定在本协议终止后仍然有效。</span>





        <p class="contentBlack">第六条 协议的变更、解除、终止</p>
        <span class="content">1、我方有权在必要时变更、中止、终止本协议，并在相关页面进行通知，变更后的协议一旦在相关的页面上公布即有效代替原来的协议。本协议条款变更后，如您继续使用聊天室服务，
            即视为您已知悉并接受变更后的协议。如您不同意我方对本协议的所作的任何变更，您应立即书面通知我方并停止在我方平台进行的任何直播服务。</span>
        <span class="content">2、双方就解除本协议协商一致即可终止协议。</span>
        <span class="content">3、您有下列情形之一，我方可以立即解除本协议，不需要提前通知：</span>
        <span class="content">（1）我方发现您违反对本协议所做的声明与承诺的；</span>
        <span class="content">（2）因您的行为直接或间接给对我方利益造成重大损害的；</span>
        <span class="content">（3）违反国家法律法规的；</span>
        <span class="content">（4）违反本协议规定的其它义务；</span>
        <span class="content">（5）以消极、不作为等不符合我方要求的方式履行本协议的（即使未构成违约），经我方通知后10日内仍未改正的；</span>
        <span class="content">（6）因异常情形的出现，我方认为您不适合进行本协议下服务事项，经我方通知后10日内异常情形仍未消除的；</span>
        <span class="content">（7）因我方业务调整，不再进行聊天室服务业务的。</span>
        <span class="content">4、由于本协议第六条第1、2款造成的协议解除、终止，我方按本协议规定及我方平台实时政策约定与您结算服务费用。</span>
        <span class="content">5、由于本协议第六条第3款造成的协议解除、终止，我方有权封禁冻结您账号并扣除您账号中尚未结算的全部服务费用，并有权要求您按约定承担违约责任。</span>
        <span class="content">6、本协议终止后，不影响本协议约定的成果的权利归属，我方仍为本协议所涉成果的权利人；如果根据中国法律，上述之约定无法实际履行的，您同意并承诺自本协议终止或双方后续合作中止、
            终止或解除之日起五年内不将聊天室成果的全部或部分的发布、使用等相关的权利（包括但不限于《中华人民共和国著作权法（2010修正）》第十条第一款第（五）项至第（十七）项规定的著作权权利）自行行使、
            转让或授权许可于任何第三方。</span>





        <p class="contentBlack">第七条 违约责任</p>    
        <span class="content">1、除本协议另有规定外，如因您的任何不实陈述或保证，或因您违反本协议项下的义务，或因您对第三方的侵权行为或违约行为，导致我方面临任何索赔、诉讼或仲裁等要求，或导致我方遭受损失，
            您应当采取适当的措施（包括但不限于与该第三方协调解决纠纷），保证我方免受任何索赔、诉讼或仲裁等，避免我方遭受损失。在该等情形下，我方保留追究您责任的权利。我方有权视您违约情节的严重程度，
            采取下列某一项或者某几项措施：</span>
        <span class="content">（1）暂时地冻结您的平台账号，直至您纠正违约行为时再恢复；</span>
        <span class="content">（2）永久性地封停/冻结您的平台账号；</span>
        <span class="content">（3）将您的平台账号永久性地删除；</span>
        <span class="content">（4）拒绝您再次注册平台账号；</span>
        <span class="content">（5）暂时中止您收益的结算和支付，直至您纠正违约行为时再进行结算和支付；</span>
        <span class="content">（6）将尚未支付给您的收益费用作为其支付给我方的违约金，不再支付给您；</span>
        <span class="content">（7）要求您于收到我方书面通知之日起5个工作日内，赔偿全部损失；</span>
        <span class="content">（8）单方解除本协议，终止双方基于本协议的所有合作事宜，不再支付尚未支付的收益费用，并有权追回所有已支付的款项。</span>
        <span class="content">2、如果您的违约行为遭到媒体曝光，导致我方遭受相应的公关危机的，我方还可以要求您发表书面声明，澄清事实并向用户和/或我方道歉。</span>
        <span class="content">3、任何一方出现违约行为，违约方应立即停止其违约行为并采取补救措施，给守约方造成损失的，应赔偿守约方因此受到的所有损失（包括直接损失和间接损失），
            守约方有权自知道违约行为发生之日起向违约方发送要求其纠正违约的书面通知。如违约方自违约行为发生之日起满15天或自收到守约方要求其纠正违约的书面通知之日起满7日仍继续进行违约行为或仍不履行其义务的，
            守约方除有权得到因此所受到的所有直接损失和间接损失的赔偿外，亦有权以书面通知违约方的方式提前终止本协议。</span>







        <p class="contentBlack">第八条 关于通知</p>  
        <span class="content">1、我方可能会以网页公告、网页/弹窗提示、电子邮箱、手机短信、常规的信件传送、您注册的平台账户的管理系统内发送站内信等方式，向您送达关于本服务的各种规则、通知、提示等信息，
            该等信息一经我方采取前述任何一种方式公布或发送，即视为送达，对您产生约束力。若您不接受的，请您书面通知我方，否则视为您已经接受、同意。</span>
        <span class="content">2、若由于您提供的电子邮箱、手机号码、通讯地址等信息错误，导致您未收到相关规则、通知、提示等信息的，您同意该情形视为您已经收到相关信息并受其约束，一切后果及责任由您自行承担。</span>
        <span class="content">3、您同意运营商向其接收信息的装置或软件包括但不限于固定电话、移动电话、电子邮箱、QQ、平台、微博、微信等发送服务信息和商业性广告。</span>
        <span class="content">4、若您有事项需要通知我方的，应当按照我方对外正式公布的联系方式书面通知我方。</span>






        <p class="contentBlack">第九条 争议处理</p>  
        <span class="content">1、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
        <span class="content">2、若您和我方之间发生任何纠纷或争议，首先应友好协商解决；协商不成功的，双方均同意将纠纷或争议提交本协议签订地有管辖权的人民法院解决。</span>
        <span class="content">3、本协议签订地：中华人名共和国长沙市雨花区高桥街道人民东路58号新三诚大厦2101房B区588号</span>






        <p class="contentBlack">第十条 责任限制</p> 
        <span class="content">1、您理解并同意，在使用本服务的过程中可能存在来自他人包括威胁性的、诽谤性的、令人反感的或非法的内容或行为，或侵犯他人权利（包括知识产权）的匿名或冒名的信息风险，
            您须承担以上风险，我方对本服务不作担保，不论是明确的或隐含的，包括所有有关信息真实性、适于某一特定用途、所有权和非侵权性的默示担保和条件，对因此导致任何因用户不正当或非法使用服务产生的直接、
            间接、偶然、特殊及后续的损害，不承担任何责任。</span>
        <span class="content">2、我方会在现有技术水平和条件下尽最大努力向您提供平台技术服务，确保服务的连贯性和安全性；但我方不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力，大规模的病毒、
            木马和黑客攻击，系统不稳定，第三方服务瑕疵，政府管制等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</span>
        <span class="content">3、在法律允许的范围内，我方对以下情形导致的服务中断或受阻均不承担责任：</span>
        <span class="content">（1）您或我方的电脑软件、系统、硬件和通信线路出现故障；</span>
        <span class="content">（2）您操作不当；</span>
        <span class="content">（3）您通过非我方授权的方式使用本服务；</span>
        <span class="content">（4）其他我方无法控制或合理预见的情形。</span>





        <p class="contentBlack">第十一条 其他</p> 
        <span class="content">1、平台规则的其他约定与本协议存在冲突的，以平台最终解释为准。</span>
        <span class="content">2、本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</span>
        <span class="content">3、本协议项下公司、平台或相关产品、功能名称、协议名称变更的，不影响本协议的履行，以实际变更后的为准。</span>
        <span class="content">4、若本协议之任何规定因与中华人民共和国法律抵触或被有管辖权的人民法院认定而无效或不可执行，则在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，
            且本协议其它规定仍应具有完整的效力及效果。</span>
        <span class="content">5、用户因自身的原因导致无法领取奖励，或领取奖励时发生任何错误而产生的任何损失或责任，平台与长沙珈颜网络科技有限公司均不承担责任，原因包括但不限于：</span>
        <span class="content">（1）因用户的平台账户失效、丢失、被禁播、被封号；</span>
        <span class="content">（2）因用户绑定的支付宝账户的原因导致的损失或责任；</span>
        <span class="content">领取过程中涉及由第三方提供相关服务的责任由该第三方承担，平台与长沙珈颜网络科技有限公司不承担该等责任，包括但不限于：</span>
        <span class="content">（1）支付宝未按照用户或平台指令进行操作引起的任何损失或责任；</span>
        <span class="content">（2）因支付宝原因导致资金未能及时到账或未能导致引起的任何损失或责任；</span>
        <span class="content">（3）支付宝交易限额或次数等方面的限制而引起的任何损失或责任。</span>

    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: '觅趣',
            companyName: '长沙珈颜网络科技有限公司',

            companyMail: 'jiayancompany@163.cn',
            companyPhone: '',
            companyAddress: '长沙市雨花区高桥街道人民东路58号新三诚大厦2101房B区588号'
        }
    },

    created() {
        document.title = "《聊天室使用协议》";
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 14px;
    color: black;
    font-weight: 700;
}
</style>